<h2 mat-dialog-title>{{ 'MANAGE_TAGS.ADD_NEW' | translate }}</h2>
<mat-dialog-content>
  <glxy-input
    placeholder="MANAGE_TAGS.NEW_TAG"
    label="MANAGE_TAGS.NAME_OF_NEW_TAG"
    [formControl]="formControl"
    (keyup.enter)="save(formControl.value)"
  ></glxy-input>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'MANAGE_TAGS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save(formControl.value)">
    {{ 'MANAGE_TAGS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
